import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { logger, UrlHelper } from './helpers';
import { GtmProvider, IntercomProvider, SentryProvider } from './providers';
import { ApolloProvider } from '@apollo/client';
import { startApollo } from './service/apollo.service';
import { LanguageHelper } from "./helpers/language.helper";
import i18next from "i18next";
import { HttpInterceptor } from "./providers/http.interceptor";
export var ExternalSourcesGunta = function () { return _jsx("link", { rel: "stylesheet", href: "https://cdn.lemonero.com/1/css/gunta.css", crossOrigin: "anonymous" }); };
export var ExternalSourcesInter = function () { return _jsx("link", { rel: "stylesheet", href: "https://cdn.lemonero.com/1/css/inter.css", crossOrigin: "anonymous" }); };
export var ExternalSourcesUbuntu = function () { return _jsx("link", { rel: "stylesheet", href: "https://cdn.lemonero.com/1/fonts/ubuntu/ubuntu.css", crossOrigin: "anonymous" }); };
export var ExternalSourcesRoboto = function () { return _jsx("link", { rel: "stylesheet", href: "https://cdn.lemonero.com/1/fonts/roboto/roboto.css", crossOrigin: "anonymous" }); };
export var ExternalSourcesOpenSans = function () { return _jsx("link", { rel: "stylesheet", href: "https://cdn.lemonero.com/1/fonts/open_sans/open_sans.css", crossOrigin: "anonymous" }); };
export var identity;
export var refreshIdentity = function (login, identityHash, email) {
    identity = login;
    if (identityHash) {
        SentryProvider.tag.set('identityHash', identityHash);
        GtmProvider.identity.set('identityHash', identityHash);
        IntercomProvider.identity.set('user_hash', identityHash);
    }
    if (email) {
        SentryProvider.tag.set('email', email);
        GtmProvider.identity.set('email', email);
        IntercomProvider.identity.set('email', email);
    }
    else {
        SentryProvider.tag.remove('email');
        GtmProvider.identity.remove('email');
        IntercomProvider.identity.remove('email');
    }
    if (login == null) {
        return logger.log('refreshIdentity', 'Unauthorized');
    }
    SentryProvider.tag.set('userId', login.userId);
    GtmProvider.identity.set('userId', login.userId);
    if (login.intercomHash) {
        SentryProvider.tag.set('identityHash', login.intercomHash);
        GtmProvider.identity.set('identityHash', login.intercomHash);
        IntercomProvider.identity.set('user_hash', login.intercomHash);
    }
    return logger.log('refreshIdentity', 'Authenticated');
};
var render = function (component, target) {
    var root = createRoot(target);
    root.render(_jsx(React.Fragment, { children: component }));
    return {
        destroy: function () { return ReactDOM.unmountComponentAtNode(target); },
    };
};
export var initLemonero = function (component, querySelector, globalStyle) {
    logger.log('initLemonero', component.props, querySelector);
    HttpInterceptor.init();
    var _a = component.props, fintechApiKUrl = _a.fintechApiKUrl, login = _a.login, sentryEnvironment = _a.sentryEnvironment, sentryUrl = _a.sentryUrl, identityHash = _a.identityHash, email = _a.email, gtmId = _a.gtmId, gitTag = _a.gitTag, sentryTunnelUrl = _a.sentryTunnelUrl;
    var language = component.props.language || LanguageHelper.detectLanguage(i18next.options.supportedLngs, i18next.options.fallbackLng[0].toString(), null);
    refreshIdentity(login, identityHash, email);
    SentryProvider.init(sentryUrl || "", sentryEnvironment, gitTag, sentryTunnelUrl);
    GtmProvider.init(gtmId);
    IntercomProvider.init(language);
    var target = document.querySelector(querySelector);
    if (target === null) {
        throw Error("Target element '".concat(querySelector, "' does not exist"));
    }
    target.style.display = target.style.display == '' ? 'inherit' : target.style.display;
    target.style.height = target.style.height == '' ? 'inherit' : target.style.height;
    target.style.width = target.style.width == '' ? 'inherit' : target.style.width;
    target.style.background = target.style.background == '' ? 'inherit' : target.style.background;
    if (fintechApiKUrl) {
        var graphqlUrl = UrlHelper.getUrl('graphql', fintechApiKUrl).href;
        var client = startApollo(graphqlUrl);
        return render(_jsxs(ApolloProvider, { client: client, children: [component, globalStyle] }), target);
    }
    else {
        return render(_jsxs(_Fragment, { children: [component, globalStyle] }), target);
    }
};
//# sourceMappingURL=boot.js.map